import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Card, Typography, Button, FormControl, TextField, MenuItem, Select, Dialog, DialogTitle, DialogContent, CardContent, Divider, LinearProgress, FormControlLabel, RadioGroup, Radio,
} from "@mui/material";
import Container from "react-bootstrap/Container";
import Modal from '@mui/material/Modal';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { styled } from "@mui/system";
import "bootstrap/dist/css/bootstrap.min.css";
import { ClipLoader } from "react-spinners";
import axios from "axios";
import dayjs from "dayjs";
import "./AddnewRfp.css";
import './Dashboard.css'
import { useSnackbar } from "../SnackbarContext";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { StaticDateTimePicker } from "@mui/x-date-pickers/StaticDateTimePicker";
import { IconButton } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import GlobalVariable from "../../services/Global";
import Trash_Empty from '../../assets/Images/Trash_Empty.svg';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PDFICON from '../../assets/Images/PDF.svg'
import CircularProgress from '@mui/material/CircularProgress';


const baseApiUrl = GlobalVariable.BASE_API_URL;




const patterns = {
  email:" ",
  url: /^(https?:\/\/[^\s/$.?#].[^\s]*)$/,
  name: /^[a-zA-Z\s]+$/,
  date: /^\d{4}-\d{2}-\d{2}$/,
  budget: /^[0-9]+(-[0-9]+)?$/,
};

const statusOptions = [
  { value: 1, label: "New" },
  { value: 4, label: "Submitted" },
  { value: 3, label: "On Hold" },
  { value: 2, label: "In Progress" },
];

const submissionModes = [
  { value: "Portal", label: "Portal" },
  { value: "Email", label: "Email" },
  { value: "Physical", label: "Physical" },
];


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 650,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  borderRadius: 4,
};


export default function AddNewRpfPage() {
  const [comments, setComments] = useState("");
  const [firstReviewDialogOpen, setfirstReviewDialogOpen] = useState(false);
  const [conferenceDialogOpen, setConferenceDialogOpen] = useState(false);
  const [questionnaireDialogOpen, setQuestionnaireDialogOpen] = useState(false);
  const [submissionDialogOpen, setSubmissionDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [documents, setDocuments] = useState([]);
  const [fileUploadModalOpen, setFileUploadModalOpen] = useState(false)
  const [file, setFile] = useState(null);
  const [addDocLoading, setAddDocLoading] = useState(false)
  const [isCloseDisabled, setIsCloseDisabled] = useState(false);
  const [documentType, setDocumentType] = useState('')
  const [fileName, setFileName] = useState('');
  const [pathData, setPathData] = useState("");
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const uploadTimer = useRef(null);
  const [paused, setPaused] = useState(false);
 
  const [formData, setFormData] = useState({
    firstReview: "",
    rfpIssuer: "",
    rfpType: "",
    location: "",
    budgetRange: "",
    expectedTimeline: "",
    website: "",
    name: "",
    email: "",
    conferenceDate: "",
    conferenceInformation: "",
    questionnaireDate: "",
    status: "",
    submissionMode: "",
    submissionDate: "",
    proceed: "no",
    internalPocName: "",
    additionalStatus: "",
  });

  const [selectedConferenceDate, setSelectedConferenceDate] = useState(
    formData.conferenceDate ? dayjs(formData.conferenceDate) : null
  );
  const [selectedQuestionnaireDate, setSelectedQuestionnaireDate] = useState(
    formData.questionnaireDate ? dayjs(formData.questionnaireDate) : null
  );
  const [selectedSubmissionDate, setSelectedSubmissionDate] = useState(
    formData.submissionDate ? dayjs(formData.submissionDate) : null
  );
  const [selectedFirstReviewDate, setSelectedFirstReviewDate] = useState(
  formData.firstReview ? dayjs(formData.firstReview) : null
);

const firstReviewTheme = createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          ...(selectedFirstReviewDate === null && {
            '&.MuiPickersDay-today': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
          ...(selectedFirstReviewDate !== null && {
            '&.MuiPickersDay-today': {
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:focus': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:hover': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
        },
      },
    },
  },
});
const conferenceTheme = createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          ...(selectedConferenceDate === null && {
            '&.MuiPickersDay-today': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
          ...(selectedConferenceDate !== null && {
            '&.MuiPickersDay-today': {
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:focus': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
        },
      },
    },
  },
});

const questionnaireTheme = createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          ...(selectedQuestionnaireDate === null && {
            '&.MuiPickersDay-today': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
          ...(selectedQuestionnaireDate !== null && {
            '&.MuiPickersDay-today': {
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:focus': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: 'black',
              boxShadow: 'none',
              outline: 'none',
            },
              '&.Mui-selected:hover': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
        },
      },
    },
  },
});

const submissionTheme = createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          ...(selectedSubmissionDate === null && {
            '&.MuiPickersDay-today': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3d3d3eff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
          ...(selectedSubmissionDate !== null && {
            '&.MuiPickersDay-today': {
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:focus': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
            '&.Mui-selected:hover': {
              border: '2px solid #3e3f3fff',
              backgroundColor: '#fff',
              color: '#3e3f3fff',
              boxShadow: 'none',
              outline: 'none',
            },
          }),
        },
      },
    },
  },
});


  const [errors, setErrors] = useState({
    firstReview: "",
    rfpIssuer: "",
    rfpType: "",
    location: "",
    budgetRange: "",
    expectedTimeline: "",
    website: "",
    name: "",
    email: "",
    conferenceDate: "",
    conferenceInformation: "",
    questionnaireDate: "",
    status: "",
    submissionMode: "",
    submissionDate: "",
    internalPocName: "",
    additionalStatus: "",
  });
  const handleFileNameChange = (event) => {
    setFileName(event.target.value);
  };
  const simulateFileUpload = useCallback((currentProgress = 0) => {
    uploadTimer.current = setInterval(() => {
      if (currentProgress < 90) {
        currentProgress += 5;
        setProgress(currentProgress);
      }
    }, 500);
  }, []);
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = error => reject(error);
    });
  };

  const formatFileSize = (size) => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return `${(size / Math.pow(1024, i)).toFixed(2)} ${['B', 'KB', 'MB', 'GB', 'TB'][i]}`;
  };
  const handleFileChange = async (event) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile) return;
    
    // Check if file is .xlsx, .csv, or .doc - these are not allowed
    const fileName = uploadedFile.name || '';
    const extension = fileName.split('.').pop()?.toLowerCase() || '';
    const isExcelOrCsv = extension === 'xlsx' || extension === 'csv';
    const isDoc = extension === 'doc';
    if (isExcelOrCsv || isDoc) {
      showSnackbar('Only PDF and DOCX files are allowed. XLSX, CSV, and DOC files are not supported.', 'error');
      event.target.value = null;
      return;
    }
    
    // Only allow PDF and DOCX
    if (extension !== 'pdf' && extension !== 'docx') {
      showSnackbar('Only PDF and DOCX files are allowed.', 'error');
      event.target.value = null;
      return;
    }
    
    const fileSizeInMB = uploadedFile.size / (1024 * 1024);
    if (fileSizeInMB > 3) {
      showSnackbar('File size exceeds greater than 3MB. Please upload a smaller file.', 'error');
      event.target.value = null;
    } else {
      if (uploadedFile) {
        setPathData(uploadedFile);
        const base64 = await convertToBase64(uploadedFile);
        setFile({
          ...uploadedFile,
          base64
        });
        // Clean fileName to remove any size information
        let cleanFileName = uploadedFile.name;
        cleanFileName = cleanFileName.replace(/\s*\([^)]*\)\s*$/, '').trim();
        cleanFileName = cleanFileName.replace(/\s*\([0-9.]+?\s*(MB|KB|GB|TB|B)\)\s*/gi, '').trim();
        setFileName(cleanFileName);
      }
    };
  }
  const filterByDocType = documents.filter(item => item.doc_type === "RFP");



  const handleFileOpen = () => setFileUploadModalOpen(true);

  const cleanUp = () => {
    clearInterval(uploadTimer.current);
    setUploading(false);
    setPaused(false);
  };
  const handleFileClose = () => {
    cleanUp();
    setFile(null);
    setFileName('');
    setDocumentType('');
    setProgress(0);
    setLoading(false);
    document.getElementById('raised-button-file').value = '';
    setFileUploadModalOpen(false);
  };

  const handleFileUpload = async () => {
    if (pathData) {
      const n = documents.filter((e) => e.doc_name !== pathData.name)
      if (n.length === 0 && documents.length !== 0) {
        showSnackbar('The file name already exists, Please re-upload.', 'warning');
      } else {
        simulateFileUpload();
        const base64 = await convertToBase64(pathData);
        let body = {
          doc_name: pathData.name,
          doc_type: documentType,
          base64: base64,
        }
        setDocuments((prevDocs) => [...prevDocs, body]);
        setIsCloseDisabled(false);
        setFileUploadModalOpen(false)
        setFileName("");
        setFile(null);
        setDocumentType("")
      }
    }

  }

  const formatDateTime = (date) => {
    return dayjs(date).format("YYYY-MM-DD HH:mm");
  };

  const validateField = (name, value) => {
    if (formData.proceed === "no" && (name === "conferenceDate" || name === "conferenceInformation" || name === "questionnaireDate")) {
      return "";
    }
    if (["expectedTimeline", "budgetRange", "firstReview", "internalPocName", "additionalStatus", "email"].includes(name)) {
      return "";
    }
    switch (name) {
      case "website":
        return /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\/.*)?$/.test(value) ? "" : "Invalid website URL";
      case "name":
        return !value || patterns.name.test(value)
          ? ""
          : "Name can only contain letters and spaces";
      case "budgetRange":
        return value
          ? /^(₹|₹ |\$|£|€|¥)? ?[0-9]+$/.test(value)
            ? ""
            : "Budget Range can have numbers with symbol(₹ | $)"
          : "";

      case "date":
        return patterns.date.test(value) ? "" : "Invalid date format";
      case "rfpIssuer":
        return patterns.name.test(value)
          ? ""
          : "RFP Issuer can only contain letters and spaces";
      default:
        return value ? "" : "This field is required";
    }
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;

    if (name === "budgetRange") {
      const numericValue = value.replace(/[^0-9]/g, '');
      value = numericValue;
    }

    if (name === "proceed") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
      return;
    }


    if (name === "conferenceDate" || name === "conferenceInformation" || name === "questionnaireDate") {
      if (formData.proceed === "no") {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
        return;
      }
    }

    const error = validateField(name, value);

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ["expectedTimeline", "budgetRange", "firstReview", "internalPocName", "additionalStatus", "email", "name"].includes(name)
        ? ""
        : value
          ? ""
          : "This field is required",
    }));

  };


  const handleRfpCancel = () => {
    navigate("/dashboard");
  };

  const handleDelete = (item) => {

    const deleteDocuments = documents.filter((i) => i.doc_name !== item);
    setDocuments(deleteDocuments);
  }

  const SpinnerContainer = styled(Box)(({ theme }) => ({
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1300,
  }));

  useEffect(() => {
    const checkFormValidity = () => {
      const allFieldsValid = Object.values(errors).every((error) => !error);
      const allFieldsFilled = Object.entries(formData).every(([key, value]) => {
        if (["expectedTimeline", "budgetRange", "firstReview", "internalPocName", "additionalStatus", "email", "name"].includes(key)) {
          return true;
        }
        if (typeof value === "string") {
          return value.trim() !== "";
        } else if (typeof value === "number") {
          return value !== null && value !== undefined;
        } else {
          return value !== null && value !== undefined;
        }
      });


      const isProceedNo = formData.proceed === "no";
      setIsFormValid(allFieldsValid && (isProceedNo || allFieldsFilled));
    };

    checkFormValidity();
  }, [formData, errors]);
  useEffect(() => {
    if (conferenceDialogOpen) {
      setTimeout(() => {
        const selectedDay = document.querySelector(
          '.MuiPickersDay-root.Mui-selected'
        );
        if (selectedDay) selectedDay.focus();
      }, 100); // Wait for calendar to render
    }
  }, [conferenceDialogOpen, selectedConferenceDate]);



  const handleSave = async () => {
    if (!isFormValid) return;

    let hasErrors = false;
    const newErrors = {};
    for (const [key, value] of Object.entries(formData)) {
      const error = validateField(key, value);
      if (error) {
        newErrors[key] = error;
        hasErrors = true;
      }
    }
    setErrors(newErrors);
    if (hasErrors) return;
    setLoading(true);

    const storedData = JSON.parse(localStorage.getItem("userDetails"));
    const userId = storedData?.userDetails?.id;

    if (!userId) {
      throw new Error("User ID not found in local storage");
    }

    const data = {
      details: {
        userid: userId,
        first_review: formData.firstReview ? formatDateTime(formData.firstReview) : "",
        rfp_issuer: formData.rfpIssuer,
        rfp_type: formData.rfpType,
        location: formData.location,
        budget_range: formData.budgetRange || "",
        expected_timeline: formData.expectedTimeline || "",
        website: formData.website,
        contact_name: formData.name || "NA",
        contact_email: formData.email,
        conference_date: formData.proceed === "no" ? "" : formatDateTime(formData.conferenceDate),
        conference_information: formData.proceed === "no" ? "" : formData.conferenceInformation,
        questionnaire_date: formData.proceed === "no" ? "" : formatDateTime(formData.questionnaireDate),
        submission_mode: formData.submissionMode,
        submission_date: formatDateTime(formData.submissionDate),
        status: formData.status,
        conference_reason: "",
        questionnaire_reason: "",
        internal_poc_name: formData.internalPocName,
        additional_status: formData.additionalStatus,
      },
      remarks: {
        userid: userId,
        remarks: "",
      },
      comments: {
        userid: userId,
        comments: comments,
      },
      filename: "",
      mulitple_files: documents
    };
    console.log("Data to be sent:", data);

    axios
      .post(`${baseApiUrl}/dashboard/addrfp`, data
      )
      .then((res) => {
        navigate("/dashboard");
        setLoading(false);
        handleReset();
        showSnackbar("RFP added successfully", "success");

      })
      .catch((error) => {
        console.error(error);
        if (error.response?.status === 401) {
          showSnackbar("Your token expired. Please again create new RFP");
          setLoading(false);
        } else {
          navigate("/404");
          setLoading(false);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDateReviewAccept = (newValue) => {
    if (newValue) {
      handleInputChange({
        target: {
          name: "firstReview",
          value: newValue.toISOString(),
        },
      });
      setSelectedFirstReviewDate(newValue);
    }
    setfirstReviewDialogOpen(false);
  };

  const handleConferenceDateAccept = (newValue) => {
    if (newValue) {
      handleInputChange({
        target: {
          name: "conferenceDate",
          value: newValue.toISOString(),
        },
      });
      setSelectedConferenceDate(newValue);
    }
    setConferenceDialogOpen(false);
  };

  const handleQuestionnaireDateAccept = (newValue) => {
    if (newValue) {
      handleInputChange({
        target: {
          name: "questionnaireDate",
          value: newValue.toISOString(),
        },
       });
      setSelectedQuestionnaireDate(newValue);
    }
    setQuestionnaireDialogOpen(false);
  };

  const handleSubmissionDateAccept = (newValue) => {
    if (newValue) {
      handleInputChange({
        target: {
          name: "submissionDate",
          value: newValue.toISOString(),
        },
      });
      setSelectedSubmissionDate(newValue);
    }
    setSubmissionDialogOpen(false);
  };


  const handleReset = () => {
    setFormData({
      firstReview: "",
      rfpIssuer: "",
      rfpType: "",
      location: "",
      budgetRange: "",
      expectedTimeline: "",
      website: "",
      name: "",
      email: "",
      conferenceDate: "",
      conferenceInformation: "",
      questionnaireDate: "",
      status: "",
      submissionMode: "",
      submissionDate: "",
      proceed: "no",
      internalPocName: "",
      additionalStatus: "",
    });
    setComments("")
    setErrors({
      firstReview: "",
      rfpIssuer: "",
      rfpType: "",
      location: "",
      budgetRange: "",
      expectedTimeline: "",
      website: "",
      name: "",
      email: "",
      conferenceDate: "",
      conferenceInformation: "",
      questionnaireDate: "",
      status: "",
      submissionMode: "",
      submissionDate: "",
      internalPocName: "",
      additionalStatus: "",
    });
  };

  return (
    <Container fluid className="ps-3 mt-2 rfpDtailsContainer ">
      <Card className="rounded-3">
        <Box style={{ paddingBottom: "16px" }}>
          <div style={{ padding: "16px 0" }}>
            <Row className="mb-2 align-items-center mx-1">
              <Col xs={12} sm={6} md={6}>
                <Typography
                  className="fontstylee MicroSoftRFPDetails_heading"
                  sx={{ width: "auto", whiteSpace: "nowrap" }}
                >
                  Add RFP Details
                </Typography>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={6}
                className=" d-flex justify-content-end"
              >
                <Button
                  className="border-primary text-primary text-capitalize rounded-2 "
                  variant="outlined"
                  color="primary"
                  onClick={handleRfpCancel}
                >
                  Back
                </Button>
              </Col>
            </Row>
          </div>
          <form style={{ marginTop: "10px" }}>
            <Container>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "16px",

                  position: "relative",
                }}
                className="mb-5"
              >
                <Typography
                  className="fontstylee"
                  sx={{
                    position: "absolute",
                    top: "-12px",
                    left: "20px",
                    background: "#fff",
                    padding: "0 8px",
                    fontSize: "16px",
                  }}
                >
                  RFP Details
                </Typography>
                <Row className="pb-2">
                  <Col lg={3} md={6}>
                    <FormControl fullWidth margin="normal" className="mt-2 search-bar">
                      <Typography
                        className="fontstyleet"
                        variant="h6"
                        gutterBottom
                      >
                        First Review
                      </Typography>
                      <TextField
                        name="firstReview"
                        value={
                          formData.firstReview
                            ? dayjs(formData.firstReview).format(
                              "YYYY-MM-DD HH:mm"
                            )
                            : ""
                        }
                        placeholder="Select date"
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <IconButton
                              onClick={() => setfirstReviewDialogOpen(true)}
                              color="primary"
                              size="large"
                            >
                              <CalendarMonthIcon sx={{ color: "#0175FF" }} />
                            </IconButton>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                      />
                      {errors.firstReview && (
                        <Typography color="error">
                          {errors.firstReview}
                        </Typography>
                      )}

                      <Dialog
                        open={firstReviewDialogOpen}
                        onClose={() => setfirstReviewDialogOpen(false)}
                        maxWidth="xs"
                        fullWidth
                        PaperProps={{
                          style: {
                            height: "85%",
                            width: "100%",
                            borderRadius: "12px",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            overflow: "auto",
                          },
                        }}
                      >
                        <DialogTitle>
                          Select First Review and Time
                          <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setfirstReviewDialogOpen(false)}
                            aria-label="close"
                            aria-hidden={false}
                            aria-modal={true}
                            sx={{
                              position: "absolute",
                              right: 16,
                              top: 8,
                              color: (theme) => theme.palette.grey[500],
                            }}
                          >
                            <CloseIcon />
                          </IconButton> 
                        </DialogTitle>
                        <DialogContent>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <ThemeProvider theme={firstReviewTheme}>
                              <StaticDateTimePicker
                                value={selectedFirstReviewDate}
                                onAccept={handleDateReviewAccept}
                                onClose={() => setfirstReviewDialogOpen(false)}
                                ampm={false}
                              />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </DialogContent>
                      </Dialog>
                    </FormControl>
                  </Col>
                  <Col lg={6} md={6}>
                    <FormControl fullWidth margin="normal" className="search-bar">
                      <Typography className="fontstyleet">
                        RFP Issuer<span style={{ color: "#ff0000" }}>*</span>
                      </Typography>
                      <TextField
                        autoComplete="current-rfpIssuer"
                        placeholder="Issuer Name"
                        name="rfpIssuer"
                        onChange={handleInputChange}
                        value={formData.rfpIssuer}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiInputBase-root": { height: "40px" },
                        }}
                      />
                      {errors.rfpIssuer && (
                        <Typography color="error">
                          {errors.rfpIssuer}
                        </Typography>
                      )}
                    </FormControl>
                  </Col>
                  <Col lg={3}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography className="fontstyleet">
                        RFP Type<span style={{ color: "#ff0000" }}>*</span>
                      </Typography>
                      <Select
                        value={formData.rfpType}
                        IconComponent={KeyboardArrowDownIcon}
                        onChange={handleInputChange}
                        name="rfpType"
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "10px",
                            height: "45px",
                          },
                          "& .MuiSelect-icon": { top: "8px", color: "#0175FF" },
                          "& .MuiOutlinedInput-input": { paddingTop: "9px" },
                        }}
                      >
                        <MenuItem className="subheader" value="Solutioning">
                          Solutioning
                        </MenuItem>
                        <MenuItem className="subheader" value="Staffing">
                          Staffing
                        </MenuItem>
                      </Select>
                      {errors.rfpType && (
                        <Typography color="error">{errors.rfpType}</Typography>
                      )}
                    </FormControl>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3} md={6}>
                    <FormControl fullWidth margin="normal" className="search-bar">
                      <Typography className="fontstyleet">
                        Location<span style={{ color: "#ff0000" }}>*</span>
                      </Typography>
                      <TextField
                        autoComplete="off"
                        placeholder="Location"
                        name="location"
                        value={formData.location}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiInputBase-root": { height: "40px" },
                        }}
                        onChange={handleInputChange}
                      />
                      {errors.location && (
                        <Typography color="error">{errors.location}</Typography>
                      )}
                    </FormControl>
                  </Col>
                  <Col lg={3} md={6}>
                    <FormControl fullWidth margin="normal" className="search-bar">
                      <Typography className="fontstyleet">
                        Budget Range($)

                      </Typography>
                      <TextField
                        placeholder="Budget Range"
                        autoComplete="off"
                        name="budgetRange"
                        value={formData.budgetRange}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiInputBase-root": { height: "40px" },
                        }}
                        onChange={handleInputChange}
                      />
                      {errors.budgetRange && (
                        <Typography color="error">
                          {errors.budgetRange}
                        </Typography>
                      )}
                    </FormControl>
                  </Col>
                  <Col lg={3}>
                    <FormControl fullWidth margin="normal" className="search-bar">
                      <Typography className="fontstyleet">
                        Expected Timeline(In months)

                      </Typography>
                      <TextField
                        placeholder="Expected Timeline"
                        autoComplete="off"
                        name="expectedTimeline"
                        value={formData.expectedTimeline}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiInputBase-root": { height: "40px" },
                        }}
                        onChange={handleInputChange}
                      />
                      {errors.expectedTimeline && (
                        <Typography color="error">
                          {errors.expectedTimeline}
                        </Typography>
                      )}
                    </FormControl>
                  </Col>
                  <Col lg={3}>
                    <FormControl fullWidth margin="normal" className="search-bar">
                      <Typography className="fontstyleet">
                        Website<span style={{ color: "#ff0000" }}>*</span>
                      </Typography>
                      <TextField
                        placeholder="Website"
                        autoComplete="off"
                        name="website"
                        value={formData.website}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiInputBase-root": { height: "40px" },
                        }}
                        onChange={handleInputChange}
                      />
                      {errors.website && (
                        <Typography color="error">{errors.website}</Typography>
                      )}
                    </FormControl>
                  </Col>
                </Row>
              </Box>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "16px",
                  position: "relative",
                }}
                className="mb-5"
              >
                <Typography
                  className="fontstylee"
                  sx={{
                    position: "absolute",
                    top: "-12px",
                    left: "20px",
                    background: "#fff",
                    padding: "0 8px",
                    fontSize: "16px",
                  }}
                >
                  Point of Contact Details
                </Typography>
                <Row>
                  <Col lg={4}>
                    <FormControl fullWidth margin="normal" className="search-bar">
                      <Typography className="fontstyleet">
                        Name
                      </Typography>
                      <TextField
                        placeholder="Name"
                        autoComplete="off"
                        name="name"
                        value={formData.name}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiInputBase-root": { height: "40px" },
                        }}
                        onChange={handleInputChange}
                      />
                      {errors.name && (
                        <Typography color="error">{errors.name}</Typography>
                      )}
                    </FormControl>
                  </Col>
                  <Col lg={4}>
                    <FormControl fullWidth margin="normal" className="search-bar">
                      <Typography className="fontstyleet">
                        Email
                      </Typography>
                      <TextField
                        placeholder="Email"
                        name="email"
                        autoComplete="off"
                        value={formData.email}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiInputBase-root": { height: "40px" },
                        }}
                        onChange={handleInputChange}
                      />
                      {errors.email && (
                        <Typography color="error">{errors.email}</Typography>
                      )}
                    </FormControl>
                  </Col>
                </Row>
              </Box>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "16px",
                  marginBottom: "16px",
                  position: "relative",
                }}
                className="mb-5"
              >
                <Typography
                  className="fontstylee"
                  sx={{
                    position: "absolute",
                    top: "-12px",
                    left: "20px",
                    background: "#fff",
                    padding: "0 8px",
                    fontSize: "16px",
                  }}
                >
                  Submission Details
                </Typography>

                <Col lg={3} md={6}>
                  <FormControl fullWidth margin="normal" className="inputfields">
                    <Typography className="fontstyleet">
                      Do you have conference date?<span style={{ color: "#ff0000" }}>*</span>
                    </Typography>
                    <RadioGroup
                      row
                      name="proceed"
                      value={formData.proceed}
                      onChange={handleInputChange}
                    >
                      <FormControlLabel
                        value="yes"
                        control={<Radio color="primary" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="no"
                        control={<Radio color="primary" />}
                        label="No"
                      />
                    </RadioGroup>
                    {errors.proceed && <Typography color="error">{errors.proceed}</Typography>}
                  </FormControl>
                </Col>
                <Row>

                  <Col lg={3} md={6}>
                    <FormControl fullWidth margin="normal" className="mt-2 inputfields">
                      <Typography variant="h6" className="fontstyleet" gutterBottom>
                        Conference Date  {formData.proceed === "yes" && (
                          <span style={{ color: "#ff0000" }}>*</span>
                        )}
                      </Typography>
                      <TextField
                        name="conferenceDate"
                        value={
                          formData.conferenceDate
                            ? dayjs(formData.conferenceDate).format("YYYY-MM-DD HH:mm")
                            : ""
                        }
                        placeholder="Select date"
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <IconButton
                              onClick={() => setConferenceDialogOpen(true)}
                              color="primary"
                              size="large"
                              disabled={formData.proceed === "no"}
                            >
                              <CalendarMonthIcon sx={{ color: "#0175FF" }} />
                            </IconButton>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiInputBase-root": { height: "40px" },
                        }}
                        disabled={formData.proceed === "no"}
                      />
                      {formData.proceed === "yes" && errors.conferenceDate && (
                        <Typography color="error">{errors.conferenceDate}</Typography>
                      )}

                      <Dialog
                        open={conferenceDialogOpen}
                        onClose={() => setConferenceDialogOpen(false)}
                        maxWidth="xs"
                        fullWidth
                        PaperProps={{
                          style: {
                            height: "85%",
                            width: "100%",
                            borderRadius: "12px",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            overflow: "auto",
                          },
                        }}
                      >
                        <DialogTitle>
                          Select Conference Date and Time
                          <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setConferenceDialogOpen(false)}
                            aria-label="close"
                            sx={{ position: "absolute", right: 9, top: 8, color: "gray" }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>
                        <DialogContent>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <ThemeProvider theme={conferenceTheme}>
                              <StaticDateTimePicker
                                value={selectedConferenceDate}
                                onAccept={handleConferenceDateAccept}
                                onClose={() => setConferenceDialogOpen(false)}
                                ampm={false}
                              />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </DialogContent>
                      </Dialog>
                    </FormControl>
                  </Col>



                  <Col lg={3} md={6}>
                    <FormControl fullWidth margin="normal" className="mt-2 inputfields">
                      <Typography variant="h6" className="fontstyleet" gutterBottom>
                        Questionnaire Date<span style={{ color: "#ff0000" }}></span>
                      </Typography>
                      <TextField
                        name="questionnaireDate"
                        value={
                          formData.questionnaireDate
                            ? dayjs(formData.questionnaireDate).format("YYYY-MM-DD HH:mm")
                            : ""
                        }
                        onChange={handleInputChange}
                        placeholder="Select date"
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <IconButton
                              onClick={() => setQuestionnaireDialogOpen(true)}
                              color="primary"
                              size="large"
                            >
                              <CalendarMonthIcon sx={{ color: "#0175FF" }} />
                            </IconButton>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiInputBase-root": { height: "40px" },
                        }}
                      />
                      {formData.proceed === "yes" && errors.questionnaireDate && (
                        <Typography color="error">{errors.questionnaireDate}</Typography>
                      )}

                      <Dialog
                        open={questionnaireDialogOpen}
                        onClose={() => setQuestionnaireDialogOpen(false)}
                        maxWidth="xs"
                        fullWidth
                        PaperProps={{
                          style: {
                            height: "85%",
                            width: "100%",
                            borderRadius: "12px",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            overflow: "auto",
                          },
                        }}
                      >
                        <DialogTitle>
                          Select Questionnaire Date and Time
                          <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setQuestionnaireDialogOpen(false)}
                            aria-label="close"
                            sx={{ position: "absolute", right: 9, top: 8, color: "gray" }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>
                        <DialogContent>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <ThemeProvider theme={questionnaireTheme}>
                              <StaticDateTimePicker
                                value={selectedQuestionnaireDate}
                                onAccept={handleQuestionnaireDateAccept}
                                onClose={() => setQuestionnaireDialogOpen(false)}
                                ampm={false}
                              />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </DialogContent>
                      </Dialog>
                    </FormControl>
                  </Col>

                  <Col lg={3} md={6}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography className="fontstyleet">
                        Status<span style={{ color: "#ff0000" }}>*</span>
                      </Typography>
                      <Select
                        value={formData.status}
                        onChange={handleInputChange}
                        IconComponent={KeyboardArrowDownIcon}
                        name="status"
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "10px",
                            height: "45px",
                          },
                          "& .MuiSelect-icon": { top: "8px", color: "#0175FF" },
                          "& .MuiOutlinedInput-input": { paddingTop: "9px" },
                        }}
                      >
                        {statusOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.status && <Typography color="error">{errors.status}</Typography>}
                    </FormControl>
                  </Col>
                  <Col lg={3} md={6}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography className="fontstyleet">
                        Submission Mode
                        <span style={{ color: "#ff0000" }}>*</span>
                      </Typography>
                      <Select
                        value={formData.submissionMode}
                        onChange={handleInputChange}
                        name="submissionMode"
                        IconComponent={KeyboardArrowDownIcon}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "10px",
                            height: "45px",
                          },
                          "& .MuiSelect-icon": { top: "8px", color: "#0175FF" },
                          "& .MuiOutlinedInput-input": { paddingTop: "9px" },
                        }}
                      >
                        {submissionModes.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.submissionMode && (
                        <Typography color="error">
                          {errors.submissionMode}
                        </Typography>
                      )}
                    </FormControl>
                  </Col>


                </Row>

                <Row>

                  <Col lg={3} md={6}>
                    <FormControl fullWidth margin="normal" className="mt-2 inputfields">
                      <Typography
                        variant="h6"
                        className="fontstyleet"
                        gutterBottom
                      >
                        Submission Date
                        <span style={{ color: "#ff0000" }}>*</span>
                      </Typography>
                      <TextField
                        name="submissionDate"
                        value={
                          formData.submissionDate
                            ? dayjs(formData.submissionDate).format(
                              "YYYY-MM-DD HH:mm"
                            )
                            : ""
                        }
                        onChange={(e) => handleInputChange(e)}
                        placeholder="Select date"
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <IconButton
                              onClick={() => setSubmissionDialogOpen(true)}
                              color="primary"
                              size="large"
                            >
                              <CalendarMonthIcon sx={{ color: "#0175FF" }} />
                            </IconButton>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                      />
                      {errors.submissionDate && (
                        <Typography color="error">
                          {errors.submissionDate}
                        </Typography>
                      )}

                      <Dialog
                        open={submissionDialogOpen}
                        onClose={() => setSubmissionDialogOpen(false)}
                        maxWidth="xs"
                        fullWidth
                        PaperProps={{
                          style: {
                            height: "85%",
                            width: "100%",
                            borderRadius: "12px",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            overflow: "auto",
                          },
                        }}
                      >
                        <DialogTitle>
                          Select Submission Date and Time
                          <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setSubmissionDialogOpen(false)}
                            aria-label="close"
                            sx={{
                              position: "absolute",
                              right: 9,
                              top: 8,
                              color: (theme) => theme.palette.grey[500],
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>
                        <DialogContent>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <ThemeProvider theme={submissionTheme }>
                              <StaticDateTimePicker
                                value={selectedSubmissionDate}
                                onAccept={handleSubmissionDateAccept}
                                onClose={() => setSubmissionDialogOpen(false)}
                                ampm={false}
                              />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </DialogContent>
                      </Dialog>
                    </FormControl>
                  </Col>
                  <Col lg={3} md={6} >
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Internal POC Name</Typography>
                      <TextField
                        placeholder="Internal POC Name"
                        name="internalPocName"
                        value={formData.internalPocName}
                        autoComplete="off"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                        onChange={handleInputChange}
                      />
                    </FormControl>
                  </Col>
                  <Col lg={3} md={6} >
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Additional Status</Typography>
                      <Select
                        name="additionalStatus"
                        value={formData.additionalStatus}
                        onChange={handleInputChange}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                            top: "2px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "10px",
                            height: "45px",
                          },
                          "& .MuiSelect-icon": {
                            top: "8px",
                            color: "blue",
                          },
                          "& .MuiOutlinedInput-input": {
                            paddingTop: "9px",
                          },
                        }}
                      >
                        <MenuItem value="Go">Go</MenuItem>
                        <MenuItem value="No Go">No Go</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>

                </Row>

                <Row>
                <Col lg={12} md={12} xs={12}>
                  <FormControl fullWidth margin="normal" className="search-bar">
                    <Typography className="fontstyleet">
                      Conference Information {formData.proceed === "yes" && (
                        <span style={{ color: "#ff0000" }}>*</span>
                      )}
                    </Typography>
                    <TextField
                      autoComplete="off"
                      name="conferenceInformation"
                      value={formData.conferenceInformation}
                      onChange={handleInputChange}
                      placeholder="Conference Information"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={1}
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                        "& .MuiInputBase-root": { height: "auto" },
                      }}
                      disabled={formData.proceed === "no"}
                    />
                    {formData.proceed === "yes" && errors.conferenceInformation && (
                      <Typography color="error">{errors.conferenceInformation}</Typography>
                    )}
                  </FormControl>
                </Col>
                </Row>
              </Box>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "16px",
                  marginBottom: "16px",
                  position: "relative",
                }}
              >
                <Typography
                  className="fontstylee"
                  sx={{
                    position: "absolute",
                    top: "-10px",
                    left: "20px",
                    background: "#fff",
                    padding: "0 8px",
                    fontSize: "16px",
                  }}
                >
                  Additional Details
                </Typography>

                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <FormControl fullWidth margin="normal" className="search-bar">
                      <Typography className="fontstyleet">
                        Comments
                      </Typography>
                      <TextField
                        placeholder="Comments"
                        autoComplete="off"
                        name="comments"
                        value={comments}
                        multiline
                        minRows={1}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiInputBase-root": { height: "auto" },
                        }}
                        onChange={(e) => setComments(e.target.value)}
                      />
                      {errors.comments && (
                        <Typography color="error">{errors.comments}</Typography>
                      )}
                    </FormControl>
                  </Col>

                </Row>
              </Box>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "16px",
                  marginBottom: "16px",
                  position: "relative",
                }}
              >
                <Card className='mt-3' sx={{ height: 420 }}>
                  <CardContent sx={{ height: '100%' }}>
                    <Row className="mb-2 align-items-center">
                      <Col xs={12} sm={6} md={6}>
                        <Typography className='fontstylee MicroSoftRFPDetails_heading'>
                          List of Documents
                        </Typography>
                      </Col>
                      <Col xs={12} sm={6} md={6} className=" d-flex justify-content-end">
                        <Button className='bg-primary text-capitalize rounded-2 '
                          variant="contained"
                          color="primary"
                          onClick={handleFileOpen}
                        >
                          Add
                        </Button>
                      </Col>
                    </Row>
                    <Card>
                      <TableContainer sx={{
                        width: '100%',
                        height: '335px',
                        overflow: 'auto',
                        '&::-webkit-scrollbar': {
                          height: '3px',
                          width: '3px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#888',
                          borderRadius: '6px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                          backgroundColor: '#555',
                          cursor: 'pointer',
                        },
                      }}>
                        <Table aria-label="simple table" stickyHeader sx={{ width: '100%' }}>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}><Typography className='fontstylee'>Document Name</Typography></TableCell>
                              <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}><Typography className='fontstylee'>Document Type</Typography></TableCell>
                              <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}><Typography className='fontstylee'>Actions</Typography></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody className='position-relative'>

                            {documents.length === 0 && !loading ? (
                              <Box
                                sx={{

                                  position: 'absolute',
                                  top: 100,
                                  left: 450,
                                }}
                              >
                                  <Typography variant="h6">No Records Found</Typography>
                              </Box>
                            ) : (

                              documents.map((doc, index) => (

                                <TableRow key={index}>
                                  <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}>
                                    <Typography
                                      className='fontstylee text-primary documentname'

                                    >
                                      {doc.doc_name}
                                    </Typography>
                                  </TableCell>
                                  <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}>{doc.doc_type}</TableCell>
                                  <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}>

                                    <IconButton
                                      onClick={() => handleDelete(doc.doc_name)}
                                    >
                                      <img src={Trash_Empty} width="31px" height="31px" alt="trshimg" style={{ backgroundColor: '#FCD9D9', borderRadius: '38%', padding: '7px' }} />
                                    </IconButton>

                                  </TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Card>
                  </CardContent>
                </Card>
              </Box>

              <Row className="d-flex justify-content-center">
                <Col lg={3}></Col>
                <Col lg={9}>
                  <Box display="flex" justifyContent="end" mt={2} mx={1}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleReset}
                      className="mx-2 border border-primary text-primary rounded-2"
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSave}
                      className={`text-capitalize rounded-3 ${isFormValid ? "button-enabled" : "button-disabled"}`}
                      disabled={!isFormValid}
                    >
                      Save
                    </Button>
                  </Box>
                </Col>
              </Row>
            </Container>
          </form>
        </Box>
        <Modal open={fileUploadModalOpen} onClose={handleFileClose} aria-labelledby="modal-title" aria-describedby="modal-description">
          <Box sx={{ ...style, width: '550px' }} className='docuploadModal'>
            {addDocLoading && (
              <Box
                className="circular-progress"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1000,
                }}
              >
                <CircularProgress className=" text-primary" />
              </Box>
            )}

            <IconButton
              aria-label="close"
              onClick={handleFileClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 5,
                color: (theme) => theme.palette.grey[500],
              }}
              disabled={isCloseDisabled}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" component="h2" textAlign="left" className='fontstyleeb fs-6 pb-1' sx={{ marginTop: '-13px' }}>
              Add New Document
            </Typography>
            <Divider />
            <Row>
              <Col lg={7} sm={6} xs={6}>
                <FormControl fullWidth margin="normal" className='inputFields inputfields'>
                  <Typography className='docName'>Document Name</Typography>
                  <TextField
                    placeholder="Document Name"
                    name="DocName"
                    className='inputFields'
                    value={fileName}
                    onChange={handleFileNameChange}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '13px',
                      },
                    }}
                  />
                </FormControl>
              </Col>
              <Col lg={5} sm={6} xs={6}>
                <FormControl fullWidth margin="normal" className='inputFields inputfields'>
                  <Typography className='docName'>Document Type</Typography>
                  <Select
                    value={documentType}
                    onChange={(e) => setDocumentType(e.target.value)}
                    name="submissionMode"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderRadius: '10px',
                      },
                      '& .MuiSelect-icon': {
                        color: 'blue',
                      },
                    }}
                  >
                    <MenuItem value="Addendum">Addendum</MenuItem>
                    <MenuItem value="Support">Support</MenuItem>
                    <MenuItem value="Final/Response">Final/Response</MenuItem>
                    {filterByDocType[0]?.doc_type !== "RFP" && (<MenuItem value="RFP">RFP</MenuItem>)}
                  </Select>
                </FormControl>
              </Col>
            </Row>
            <Box
              sx={{
                backgroundColor: 'rgba(215, 233, 245)',
                border: '1px dashed blue',
                borderRadius: '5px',
                textAlign: 'center',
                p: 6,
                mt: 1,
                mb: 2,
                position: 'relative',
                width: '100%',
              }}
              className='docuploadBox'
            >
              <Box onClick={() => document.getElementById('raised-button-file').click()}>
                <img src={PDFICON} alt='PDFICON' width={'70px'} height={'84px'} style={{ cursor: 'pointer' }} className='addRfpdoc' />
              </Box>

              {!file && (
                <>
                  <Typography className='dragText'>Drag and Drop your File here, or{' '}
                    <label htmlFor="raised-button-file" style={{ color: '#007bff', cursor: 'pointer' }}>
                      Browse Files
                    </label>
                  </Typography>
                  <Typography sx={{ color: '#888', fontSize: '12px' }} className='dragText'>
                    Limit 50MB per file PDF, DOCX Files Only
                  </Typography>
                </>
              )}

              {file && (
                <>
                  <Typography sx={{ fontSize: '14px', mt: 1 }} className='uploadDocName' style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                    {(() => {
                      const displayName = fileName || (file?.name || '');
                      // Remove any size patterns like "(2.92 MB)", "(2.5 KB)", etc.
                      return displayName.replace(/\s*\([^)]*\)\s*$/, '').replace(/\s*\([0-9.]+?\s*(MB|KB|GB|TB|B)\)\s*/gi, '').trim();
                    })()}
                  </Typography>
                  <Typography sx={{ color: '#888', fontSize: '12px', mt: 1 }} className='dragText'>
                    Limit 50MB per file PDF, DOCX Files Only
                  </Typography>
                </>
              )}

              <input
                accept=".pdf,.docx,.xlsx,.csv"
                style={{ display: 'none' }}
                id="raised-button-file"
                type="file"
                onChange={handleFileChange}
              />
            </Box>
            {uploading && (
              <Box sx={{ width: '100%' }}>
                <div className='border border-1px solid grey p-2'>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box display="flex" alignItems="center">
                      <img src={PDFICON} alt='PDFICON' width={'30px'} height={'42px'} style={{ cursor: 'pointer' }} className='pb-2 mx-1' />
                      <div style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        <Typography className='uploadDocName' style={{ textDecoration: 'none', textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                          {(() => {
                            const displayName = fileName || (file?.name || '');
                            // Remove any size patterns like "(2.92 MB)", "(2.5 KB)", etc.
                            return displayName.replace(/\s*\([^)]*\)\s*$/, '').replace(/\s*\([0-9.]+?\s*(MB|KB|GB|TB|B)\)\s*/gi, '').trim();
                          })()}
                        </Typography>
                      </div>
                    </Box>
                  </Box>
                  <LinearProgress variant="determinate" value={progress} sx={{
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: '#4caf50',
                    },
                    mt: 1,
                  }} />
                </div>
              </Box>
            )}
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <div>
                {file && fileName && documentType && (
                  <Button color="primary" onClick={handleFileUpload} className='rounded-2 bg-primary text-white' disabled={addDocLoading}>
                    Save
                  </Button>
                )}
              </div>
            </Box>
          </Box>
        </Modal>
      </Card>
      {loading && (
        <SpinnerContainer>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <ClipLoader size={50} color="#123abc" loading={loading} />
            <Typography variant="h6" sx={{ mt: 2, color: '#123abc' }}>Analyzing Rfp...</Typography>
          </Box>
        </SpinnerContainer>
      )}
    </Container>
  );
}